// extracted by mini-css-extract-plugin
module.exports = {"star":"staranimation_star___1jJh","animate":"staranimation_animate__wX6WH","bigStar":"staranimation_bigStar__7iggw"};